import { render, staticRenderFns } from "./AsideMenu.vue?vue&type=template&id=85bf9d6c&scoped=true&"
import script from "./AsideMenu.vue?vue&type=script&lang=js&"
export * from "./AsideMenu.vue?vue&type=script&lang=js&"
import style0 from "./AsideMenu.vue?vue&type=style&index=0&id=85bf9d6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bf9d6c",
  null
  
)

export default component.exports